export const queryParams = new URLSearchParams(window.location.search);

export const isEmbed = (): boolean =>
  window.location.pathname.split('/')[1] === 'embed';
